import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scratchwork.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scratchwork.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/views/scratchwork/scratchwork.vue?vue&type=script&lang=js&
// module id = isGo
// module chunks = 0